import { render } from "./StoreRoadmapOverview.vue?vue&type=template&id=7dd60750"
import script from "./StoreRoadmapOverview.vue?vue&type=script&lang=js"
export * from "./StoreRoadmapOverview.vue?vue&type=script&lang=js"
/* custom blocks */
import block0 from "./StoreRoadmapOverview.i18n.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Ftmp%2Fbuild_36689b7c%2Fpackages%2Fstore%2Fsrc%2Fviews%2Fcommon%2FStoreRoadmapOverview.vue&external"
if (typeof block0 === 'function') block0(script)


import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__